// 회원 등급 시스템 유틸리티

// 등급 정의 (낮은 순서부터 높은 순서)
export const GRADES = {
  NEWBIE: 'newbie',
  BRONZE: 'bronze', 
  SILVER: 'silver',
  GOLD: 'gold',
  PLATINUM: 'platinum',
  DIAMOND: 'diamond'
};

// 등급 순서 배열 (인덱스가 높을수록 높은 등급)
export const GRADE_ORDER = [
  GRADES.NEWBIE,
  GRADES.BRONZE,
  GRADES.SILVER,
  GRADES.GOLD,
  GRADES.PLATINUM,
  GRADES.DIAMOND
];

// 등급별 표시 정보
export const GRADE_INFO = {
  [GRADES.NEWBIE]: {
    name: '뉴비',
    icon: '🌱',
    color: '#95a5a6',
    level: 0
  },
  [GRADES.BRONZE]: {
    name: '브론즈',
    icon: '🥉',
    color: '#cd7f32',
    level: 1
  },
  [GRADES.SILVER]: {
    name: '실버',
    icon: '🥈',
    color: '#c0c0c0',
    level: 2
  },
  [GRADES.GOLD]: {
    name: '골드',
    icon: '🥇',
    color: '#ffd700',
    level: 3
  },
  [GRADES.PLATINUM]: {
    name: '플래티넘',
    icon: '💎',
    color: '#e5e4e2',
    level: 4
  },
  [GRADES.DIAMOND]: {
    name: '다이아몬드',
    icon: '💎',
    color: '#b9f2ff',
    level: 5
  }
};

/**
 * 등급 문자열을 등급 레벨(숫자)로 변환
 * @param {string} grade - 등급 문자열
 * @returns {number} 등급 레벨 (0-5, -1은 유효하지 않은 등급)
 */
export const getGradeLevel = (grade) => {
  if (!grade || typeof grade !== 'string') {
    return -1;
  }
  
  const gradeInfo = GRADE_INFO[grade.toLowerCase()];
  return gradeInfo ? gradeInfo.level : -1;
};

/**
 * 등급 정보 가져오기
 * @param {string} grade - 등급 문자열
 * @returns {object} 등급 정보 객체
 */
export const getGradeInfo = (grade) => {
  if (!grade || typeof grade !== 'string') {
    return GRADE_INFO[GRADES.NEWBIE]; // 기본값은 뉴비
  }
  
  return GRADE_INFO[grade.toLowerCase()] || GRADE_INFO[GRADES.NEWBIE];
};

/**
 * 두 등급을 비교하여 첫 번째 등급이 두 번째 등급보다 높은지 확인
 * @param {string} grade1 - 비교할 등급 1
 * @param {string} grade2 - 비교할 등급 2
 * @returns {boolean} grade1이 grade2보다 높으면 true
 */
export const isGradeHigherOrEqual = (grade1, grade2) => {
  const level1 = getGradeLevel(grade1);
  const level2 = getGradeLevel(grade2);
  
  // 유효하지 않은 등급은 가장 낮은 등급으로 처리
  if (level1 === -1) return false;
  if (level2 === -1) return true;
  
  return level1 >= level2;
};

/**
 * 등급에 따른 권한 확인
 * @param {string} userGrade - 사용자 등급
 * @param {string} requiredGrade - 필요한 최소 등급
 * @returns {boolean} 권한이 있으면 true
 */
export const hasGradePermission = (userGrade, requiredGrade) => {
  // 필요한 등급이 없으면 모든 사용자에게 허용
  if (!requiredGrade) {
    return true;
  }
  
  // 사용자 등급이 없으면 거부
  if (!userGrade) {
    return false;
  }
  
  return isGradeHigherOrEqual(userGrade, requiredGrade);
};

/**
 * 등급을 표시용 문자열로 변환
 * @param {string} grade - 등급 문자열
 * @returns {string} 표시용 등급 문자열 (아이콘 + 이름)
 */
export const formatGradeDisplay = (grade) => {
  const gradeInfo = getGradeInfo(grade);
  return `${gradeInfo.icon} ${gradeInfo.name}`;
};